export function requireCompanyId(companyId: string | null): string {
  if (!companyId) {
    throw new Error('Company context is not ready yet.');
  }
  return companyId;
}
